import { useHistory } from "react-router-dom";
import { AutoSizer,Column, Table } from "react-virtualized";
import PropTypes from "prop-types";

import "react-virtualized/styles.css";

/** Table columns configuration */
const columns = [
  { field: "username", headerName: "Username", width: 140 },
  { field: "firstName", headerName: "First Name", width: 130 },
  { field: "lastName", headerName: "Surname", width: 130 },
  { field: "age", headerName: "Age", width: 70 },
  { field: "lastAssessmentDate", headerName: "Last Assessment", width: 170 },
  { field: "firstAssessmentDate", headerName: "First Assessment", width: 170 },
  { field: "totalAssessments", headerName: "Total Assessments", width: 180 },
  { field: "trend", headerName: "Trend", width: 120 },
];

export const MPatientsTable = ({ patientsList }) => {
  const history = useHistory();

  const redirectToPage = (patient) => {
    if (!patient.isUpToDate) return;
    sessionStorage.setItem("patient", JSON.stringify(patient));
    sessionStorage.setItem("from_redirect", true);
    history.push(`/patient/${patient.username}`);
  };

  // Generate table data
  const dataGrid = patientsList.map((p, idx) => ({
    ...p,
    id: `p-${idx}`,
    totalAssessments: p.activities.length,
  }));

  return (
    <div style={{ height: "100%", width: "100%", padding: 5, borderRadius: 8 }}>
      <AutoSizer>
        {({ height, width }) => (
          <Table
            width={width}
            height={height}
            headerHeight={50}
            rowHeight={40}
            rowCount={dataGrid.length}
            rowGetter={({ index }) => dataGrid[index]}
            rowClassName={({ index }) => {
              if (index == -1) return ""
              return `table-row-${index % 2 === 0 ? "even" : "odd"}`
              }
            }
            onRowClick={({ rowData }) => redirectToPage(rowData)}
            style={{backgroundColor: "green", textTransform: "none"}}
          >
            {columns.map((col) => (
              <Column
                key={col.field}
                label={col.headerName}
                dataKey={col.field}
                width={col.width}
                headerStyle={{textTransform: "none" }}
              />
            ))}
          </Table>
        )}
      </AutoSizer>
      
      <style>
        {`
          .table-row {
            cursor: pointer;
            transition: background 0.2s ease-in-out;
          }
          .table-row-even {
            background: #f9f9f9;
          }
          .table-row-even:hover {
            background: rgba(0, 153, 255, 0.2);
            }

          .table-row-odd {
            background: #ffffff;
          }
          .table-row-odd:hover {
            background: rgba(0, 153, 255, 0.2);
          }
        `}
      </style>
    </div>
  );
};

MPatientsTable.propTypes = {
  patientsList: PropTypes.array.isRequired,
};